import { Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/system';

const H3_SECTION_TITLES = new Set(['investment details', 'investment & payment details']);

export const getSectionHeadingLevel = (title: string): 2 | 3 => {
  if (H3_SECTION_TITLES.has(title.trim().toLowerCase())) {
    return 3;
  }
  return 2;
};

const formPageTitleSx: SxProps<Theme> = {
  fontFamily: 'Poppins, sans-serif',
  fontSize: { xs: 18, md: 25 },
  fontWeight: 500,
  mb: { xs: 2, md: 3.5 },
  wordBreak: 'break-word',
};

const detailsSectionSx: SxProps<Theme> = {
  fontSize: 18,
  fontWeight: 600,
  color: 'primary.main',
};

export function ApplicationSectionHeading({
  title,
  level,
  variant = 'details',
  sx,
}: {
  title: string;
  level?: 2 | 3;
  variant?: 'form' | 'details';
  sx?: SxProps<Theme>;
}): JSX.Element {
  const headingLevel = level ?? getSectionHeadingLevel(title);
  const baseSx = variant === 'form' ? formPageTitleSx : detailsSectionSx;
  const HeadingTag = headingLevel === 3 ? 'h3' : 'h2';

  return (
    <Typography component={HeadingTag} variant="inherit" sx={{ m: 0, p: 0, ...baseSx, ...sx }}>
      {title}
    </Typography>
  );
}
